export default __webpack_public_path__ + "images/Pub-Food.84a49d.jpg";